export const environment = {
  production: true,
  web: 'https://empresaconvenio.uninter.com/',
  api: 'https://empresaconvenioapi.uninter.com/',
  ambiente: 'PROD',
  apiAccount: 'https://accountapi.uninter.com/',
  webAccount: 'https://account.uninter.com/',
  loginUnificadoUrl: 'https://login.uninter.com'
};